<template>
    <v-container fluid pa-5 dark flat>
        <v-layout row wrap class="inner-container" justify-center mx-auto>
            <v-container px-0 py-3 flat>
                <v-stepper v-model="e1">
                    <v-stepper-header style="display:none">
                        <v-stepper-step 
							:complete="e1 > 1"
							step="1" 
						>BlogHome
                        </v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 2"
							step="2"
						>Ejemplo</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 3"
							step="3"
						>Ejemplo2</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 4"
							step="4"
						>Articulo3</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                        <!-- Nombre -->
                        <BlogHome/>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- Elementos -->
                        <Post1/>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <Post2/>     
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <Post3/>     
                    </v-stepper-content>
                    <v-stepper-content step="5">
                        <Post4/>     
                    </v-stepper-content>
                </v-stepper>
            </v-container>
        </v-layout>
    </v-container>
</template>        
<script>
import { EventBus } from '../../events.js'
import BlogHome from './Blog/BlogHome.vue'
import Post1 from './Blog/Salvoconducto_de_Mudanzas.vue'
import Post2 from './Blog/Tips_mudanza.vue'
import Post3 from './Blog/RdelaRopa.vue'
import Post4 from './Blog/HUM.vue'


export default {
    components: {
        BlogHome,
        Post1,
        Post2,
        Post3,
        Post4,
    },
    data () {
        return{
            e1 : 1,
        }
    },
    mounted(){
        console.log("estoy cargando el blog")
        EventBus.$on('BlogHome->Articulo1', async data =>{
            this.e1 = data
            window.scrollTo(0,0)      
        })
        EventBus.$on('BlogHome->Articulo2', async data =>{
            this.e1 = data
            window.scrollTo(0,0)      
        })
        EventBus.$on('BlogHome->Articulo3', async data =>{
            this.e1 = data
            window.scrollTo(0,0)      
        })
        EventBus.$on('BlogHome->Articulo4', async data =>{
            this.e1 = data
            window.scrollTo(0,0)      
        })

        EventBus.$on('Retroceder', async data =>{
            this.e1 = data
            window.scrollTo(0,0)      
        })
    }
}
</script>
